import { CarcinogenicReportWorker, CarcinogenicReportWorkerRisk } from "./types";

export const isExposed = (worker: CarcinogenicReportWorker): boolean => {
    return worker?.puestoTrabajo?.riesgos?.some(
        (risk: CarcinogenicReportWorkerRisk) => risk.cancerigeno === true
    );
};


export const getItemFromId = (id: number, array: any) => {
    const item = array?.find((item: any) => item.id === id);
    return item || '-';
};

/**
 * La norma solo admite trabajadores vinculados a la sustancia durante el año
 * calendario anterior — un trabajador que ingresó en el año en curso no
 * puede declararse expuesto.
 */
export const esIngresoEnAnioEnCurso = (fechaIngreso: string | '' | undefined): boolean => {
    if (!fechaIngreso) return false;
    return new Date(fechaIngreso).getFullYear() >= new Date().getFullYear();
};
